var map = {
	"./auth.js": "4K/y"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4Atj";


//////////////////
// WEBPACK FOOTER
// ./middleware nonrecursive ^\.\/(?!-)[^.]+\.(js)$
// module id = 4Atj
// module chunks = 13